import { z } from 'zod';

import { UserId } from '../../../BrandedIds';
import { zodBrandedString } from '../../../utils/Zod';

/**
 * Assignment
 */

export const NoAssignment = z.object({
  type: z.literal('noAssignment'),
});

export type NoAssignment = z.infer<typeof NoAssignment>;

export const AssignToUser = z.object({
  type: z.literal('assignToUser'),
  userId: zodBrandedString<UserId>().meta({
    description: 'The ID of the user to assign the step to.',
    example: 'c0ef58c7-4f5c-4352-a775-2a75ea4c6d88',
    type: 'string',
  }),
});

export type AssignToUser = z.infer<typeof AssignToUser>;

export const AssignToLoanPointOfContact = z.object({
  type: z.literal('assignToLoanPointOfContact'),
});

export type AssignToLoanPointOfContact = z.infer<typeof AssignToLoanPointOfContact>;

export const AssignToTeam = z.object({
  type: z.literal('assignToTeam'),
  teamId: z.string(), // TODO branded
  choose: z.union([z.literal('first'), z.literal('random')]), // TODO smarter assignment -- round robin, "default assignee" on team, something else?
});

export type AssignToTeam = z.infer<typeof AssignToTeam>;

export const AssignmentDefinition = z.union([NoAssignment, AssignToUser, AssignToLoanPointOfContact, AssignToTeam]);
export type AssignmentDefinition = z.infer<typeof AssignmentDefinition>;
